import { configureStore } from "@reduxjs/toolkit";
import tenantInformationStore from "./slices/tenant/tenant-slice";
import sidebarStore from "./slices/sidebar/sidebar-slice";

export const store = configureStore({
  reducer: {
    tenantInformation: tenantInformationStore,
    sidebar: sidebarStore,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
